// DO NOT USE ANYTHNING IN THIS FILE
// IT EXISTS ONLY FOR AN EXPERIMENT
// AND ISN'T HOW YOU GET THESE THINGS
import wrapper from "./wrapper";

const CachedViewers = {};

const createTemporaryPageViewer = isbn => {
  return new Promise((resolve, reject) => {
    const cachedViewer = CachedViewers[isbn] || {};
    CachedViewers[isbn] = cachedViewer;
    // TODO: Is this doing anything?
    // eslint-disable-next-line no-unused-expressions
    cachedViewer.viewer;
    if (cachedViewer.loaded) {
      resolve(cachedViewer.viewer);
    } else if (cachedViewer.isLoading) {
      resolve(cachedViewer.promise);
    } else {
      cachedViewer.isLoading = true;
      cachedViewer.promise = new Promise(cachedResolve => {
        const viewer = Jigsaw.createPageViewer(
          {
            vbid: isbn,
            page: "recent",
            highlightsEnabled: false,
            swipeDisabled: true,
            brand: Fraction.Brand.jigsawBrand,
            autofocus: false,
            el: `temp-jigsaw-placeholder-${isbn}`,
            zoomDisabled: true,
            noteIcon: { svgIcon: true }
          },
          response => {
            cachedViewer.isLoading = false;
            cachedViewer.loaded = true;
            cachedViewer.viewer = viewer;
            cachedResolve(viewer);
            resolve(viewer);
            // TODO if the viewer fails (don't have access, not build, etc)
          }
        );
      });
    }
  });
};

export default {
  getTableOfContents: async isbn => {
    const viewer = await createTemporaryPageViewer(isbn);
    return new Promise((resolve, reject) => {
      viewer.Book.getTOC(response => {
        if (response.isSuccess()) {
          resolve(response.data.toc);
        } else {
          reject("error with toc"); // TODO add real error
        }
      });
    });
  },

  getPageBreaks: async isbn => {
    const viewer = await createTemporaryPageViewer(isbn);
    return new Promise((resolve, reject) => {
      viewer.Book.getPageBreaks(response => {
        if (response.isSuccess()) {
          resolve(response.data.pagebreaks);
        } else {
          reject("error with pagebreaks"); // TODO add real error
        }
      });
    });
  },

  getHighlights: async isbn => {
    const viewer = await createTemporaryPageViewer(isbn);
    return new Promise((resolve, reject) => {
      viewer.Book.getHighlights(response => {
        if (response.isSuccess()) {
          resolve(response.data.highlights);
        } else {
          reject("error with highlights"); // TODO add real error
        }
      });
    });
  },

  getBookmarks: async isbn => {
    const viewer = await createTemporaryPageViewer(isbn);
    return new Promise((resolve, reject) => {
      viewer.Book.getBookmarks(response => {
        if (response.isSuccess()) {
          resolve(response.data.bookmarks);
        } else {
          reject("error with bookmarks"); // TODO add real error
        }
      });
    });
  },

  getHighlightSummary: () => wrapper("User.getHighlightSummary")
};
